module.exports = __webpack_public_path__ + "img/buzz-1.cd20abdf.png";